import React from 'react';
import Card from 'components/Card';
import PlaceholderText from 'components/PlaceholderText';

import {
  PlaceholderCardContainer,
  PlaceholderCardHeader,
  PlaceholderCardDate,
  PlaceholderCardContent,
  PlaceholderCardTitle,
} from './styles';

const PlaceholderCard = () => (
  <Card>
    <PlaceholderCardContainer>
      <PlaceholderCardHeader>
        <PlaceholderCardDate>
          <PlaceholderText height={20} maxWidth={120} />
        </PlaceholderCardDate>
      </PlaceholderCardHeader>
      <PlaceholderCardContent>
        <PlaceholderCardTitle>
          <PlaceholderText height={34} maxWidth={150} />
        </PlaceholderCardTitle>
      </PlaceholderCardContent>
    </PlaceholderCardContainer>
  </Card>
);

export default PlaceholderCard;
